export default __webpack_public_path__ + "static/media/mc-dektop.22257abc.png";